import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

export function formatDate(date) {
  if (!date) return 'N/A';

  try {
    const parsed = dayjs(date);
    return parsed.isValid() ? parsed.format('DD-MM-YYYY') : 'N/A';
  } catch {
    return 'N/A';
  }
}

export function formatDateWithTimestamp(date) {
  if (!date) return 'N/A';

  try {
    const parsed = dayjs(date);
    return parsed.isValid() ? parsed.format('DD-MM-YYYY hh:mm:ss A') : 'N/A';
  } catch {
    return 'N/A';
  }
}

export const formatToIsoDate = (date) => {
  if (!date) return 'N/A';

  try {
    const parsed = dayjs(date);
    return parsed.isValid() ? parsed.toISOString().split('T')[0] : 'N/A';
  } catch {
    return 'N/A';
  }
};

export const formatDateRangeLabel = ({ start, end }) => {
  const startDate = new Date(start);
  const endDate = new Date(end);

  const year = startDate.getFullYear();
  const month = startDate.toLocaleString('en-US', { month: 'short' });
  const startDay = String(startDate.getDate()).padStart(2, '0');
  const endDay = String(endDate.getDate()).padStart(2, '0');

  return `${startDay}-${endDay} ${month.toUpperCase()}, ${year}`;
};

export const formatDateToDashboardFormat = (inputDate) => {
  const date = new Date(inputDate);
  const month = date.toLocaleString('en-US', { month: 'short' });
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  return `${day} ${month.toUpperCase()}, ${year}`;
};

export const convertMonthYearToDate = (monthYearString, isStartDate) => {
  if (!monthYearString) return null;

  // Parse "January 2024" format
  const parsed = dayjs(monthYearString, 'MMMM YYYY', true);
  if (!parsed.isValid()) {
    // Fallback: try parsing as regular date string
    const fallback = dayjs(monthYearString);
    if (!fallback.isValid()) return null;
    return isStartDate ? fallback.startOf('month').format('YYYY-MM-DD') : fallback.endOf('month').format('YYYY-MM-DD');
  }

  return isStartDate ? parsed.startOf('month').format('YYYY-MM-DD') : parsed.endOf('month').format('YYYY-MM-DD');
};

export const formatToOMNDateTime = (timestamp) => {
  if (!timestamp) return 'N/A';

  try {
    const omnTime = dayjs.utc(timestamp).tz('Asia/Muscat');
    return omnTime.isValid() ? `${omnTime.format('MMM DD, YYYY, hh:mm:ss A')} GST` : 'N/A';
  } catch {
    return 'N/A';
  }
};
